import { useLazyQuery, useQuery } from '@apollo/client';
import ClearIcon from "@mui/icons-material/Clear";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight"; // Upewnij się, że to jest poprawny import
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Container, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import LinearProgress from "@mui/material/LinearProgress";
import MenuItem from "@mui/material/MenuItem";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import Stack from '@mui/material/Stack';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { GET_WELDS } from "../graphql/getWelds";
import { GET_WELDS_FILTERS } from '../graphql/getWeldsFilters';
import { GET_DICTIONARIES } from '../graphql/getDictionaries';
import { GET_WELDERS } from '../graphql/getWelders';

const removeFromHash = (hash, ...keysToRemove) => {
  return Object.entries(hash)
    .filter(([key]) => !keysToRemove.includes(key))
    .reduce((obj, [key, value]) => ({
      ...obj,
      [key]: value
    }), {});
};

const clearHash = (params) => {
  return Object.entries(params)
    .filter(([_, value]) => value !== null && value !== '')
    .reduce((acc, [key, value]) => {
      // Ensure inspection_percent is an integer
      if (key === 'inspection_percent' && value !== '') {
        acc[key] = parseInt(value, 10);
      } else {
        acc[key] = value;
      }
      return acc;
    }, {})
}

export default function Welds() {
  const [elementId] = useState(Number(useParams().elementId));
  const [projectId] = useState(Number(useParams().projectId));
  const [searchParams, setSearchParams] = useSearchParams();
  const [applyFilters] = useState(false);
  const permissions = localStorage.permissions ? JSON.parse(localStorage.permissions) : { wl_welds: { welding_logs: {}, grinding_logs: {}, inspection_logs: {} } }

  const [urlParams, setUrlParams] = useState({
    no: searchParams.get('no') || '',
    weld_joint_type: searchParams.get('weld_joint_type') || '',
    length: searchParams.get('length') || '',
    material_1: searchParams.get('material_1') || '',
    material_2: searchParams.get('material_2') || '',
    wps: searchParams.get('wps') || '',
    inspection_category: searchParams.get('inspection_category') || '',
    empty_inspection_category_type: searchParams.get('empty_inspection_category_type') || '',
    inspection_percent: searchParams.get('inspection_percent') || '',
    last_welding_welder_id: searchParams.get('last_welding_welder_id') || '',
    last_welding_date: searchParams.get('last_welding_date') || '',
    status: searchParams.get('status') || '',
    page: parseInt(searchParams.get('page') || '1'),
    size: parseInt(searchParams.get('size') || '10')
  });

  const [pageSize, setPageSize] = useState(10);

  const [tempFilters, setTempFilters] = useState(urlParams);
  const [selectedWelds, setSelectedWelds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);


  const { data, loading, error, refetch } = useQuery(GET_WELDS, {
    variables: {
      projectId: elementId,
      page: urlParams.page,
      size: urlParams.size,
      filters: clearHash(removeFromHash(urlParams, 'page', 'size')),
    },
  });

  const [optionsMaterial1, setOptionsMaterial1] = useState([]);
  const [inputTextMaterial1, setInputTextMaterial1] = useState("");
  const [optionsMaterial2, setOptionsMaterial2] = useState([]);
  const [inputTextMaterial2, setInputTextMaterial2] = useState("");
  const [optionsWPS, setOptionsWPS] = useState([]);
  const [inputTextWPS, setInputTextWPS] = useState("");
  const [optionsWeldType, setOptionsWeldType] = useState([]);
  const [inputTextWeldType, setInputTextWeldType] = useState("");
  const [optionsStatus, setOptionsStatus] = useState([{ id: 'new', label: 'New' }, { id: 'ready', label: 'Ready' }, { id: 'in_progress', label: 'In progress' }, { id: 'ok', label: 'Ok' }, { id: 'failed', label: 'Failed' }, { id: 'inconsistent', label: 'Inconsistent' }]);
  const [inputTextStatus, setInputTextStatus] = useState("");
  const [optionsInspectionCategory, setOptionsInspectionCategory] = useState([]);
  const [inputTextInspectionCategory, setInputTextInspectionCategory] = useState("");
  const [optionsInspectionCategoryType, setOptionsInspectionCategoryType] = useState([]);
  const [inputTextInspectionCategoryType, setInputTextInspectionCategoryType] = useState("");
  const inspectionCategoryTypeSelected = useMemo(
    () => optionsInspectionCategoryType?.find((type) => type.id === urlParams.empty_inspection_category_type || type.id === Number(urlParams.empty_inspection_category_type)),
    [optionsInspectionCategoryType, urlParams.empty_inspection_category_type]
  );
  const [optionsInspectionPercent, setOptionsInspectionPercent] = useState([]);
  const [inputTextInspectionPercent, setInputTextInspectionPercent] = useState("");
  const inspectionPercentSelected = useMemo(
    () => optionsInspectionPercent?.find((percent) => percent.id === urlParams.inspection_percent || percent.id === Number(urlParams.inspection_percent)),
    [optionsInspectionPercent, urlParams.inspection_percent]
  );
  const [getWledFilters] = useLazyQuery(GET_WELDS_FILTERS);
  const { data: dictionariesData } = useQuery(GET_DICTIONARIES);
  const { data: weldersData } = useQuery(GET_WELDERS, {
    variables: {
      permission_key: 'core.people.welder',
      active: 'true'
    }
  });
  const [optionsWelders, setOptionsWelders] = useState([]);
  const welderSelected = useMemo(
    () => optionsWelders?.find((welder) => welder.id === urlParams.last_welding_welder_id),
    [optionsWelders, urlParams.last_welding_welder_id]
  );

  useEffect(() => {
    setOptionsMaterial1([]);
    setOptionsMaterial2([]);
    setOptionsWPS([]);
    setOptionsWeldType([]);
    setOptionsStatus([{ id: 'new', label: 'New' }, { id: 'ready', label: 'Ready' }, { id: 'in_progress', label: 'In progress' }, { id: 'ok', label: 'Ok' }, { id: 'failed', label: 'Failed' }, { id: 'inconsistent', label: 'Inconsistent' }]);
    setOptionsInspectionCategory([]);
    setOptionsInspectionCategoryType([]);
    setOptionsInspectionPercent([]);

    getWledFilters({
      variables: {
        base_material_1: inputTextMaterial1,
        base_material_2: inputTextMaterial2,
        size: 10,
        element_id: elementId,
        project_id: projectId,
      }
    }).then((response) => {
      setOptionsMaterial1(response.data?.base_materials_1.map(base_material => ({ id: base_material.id, label: base_material.designation_name })));
      setOptionsMaterial2(response.data?.base_materials_2.map(base_material => ({ id: base_material.id, label: base_material.designation_name })));
      setOptionsWPS(response.data?.wps_list?.list.map(wps => ({ id: wps.id, label: wps.no })));
      setOptionsWeldType(getWeldType(response.data?.type_of_welds, response.data?.joint_types));
      setOptionsStatus(response.data?.available_weld_statuses?.map(status => ({ id: status.code, label: status.name })));
      setOptionsInspectionCategory(response.data?.inspection_categories?.map(category => ({ id: category.id, label: category.name })) || []);

      // Get unique type_ids from inspection categories
      const categories = response.data?.inspection_categories || [];
      const typeIdSet = new Set();
      const percentSet = new Set();

      categories.forEach(cat => {
        (cat.inspections || []).forEach(insp => {
          typeIdSet.add(insp.type_id);
          percentSet.add(insp.range || '100');
        });
      });

      // Map type_ids to names from dictionary
      const typeIdArray = Array.from(typeIdSet);
      if (dictionariesData?.inspection_category_types) {
        const typeOptions = typeIdArray.map(typeId => {
          const dictType = dictionariesData.inspection_category_types.find(t => t.id === typeId);
          return {
            id: typeId,
            label: dictType ? dictType.name : `Type ${typeId}`
          };
        });
        setOptionsInspectionCategoryType(typeOptions);
      }

      // Create options for inspection percentages
      const percentArray = Array.from(percentSet);
      const percentOptions = percentArray.map(percent => ({
        id: parseInt(percent, 10), // Convert to integer for GraphQL
        label: `${percent}%`
      }));
      setOptionsInspectionPercent(percentOptions);
    });
  }, [projectId, elementId, getWledFilters, inputTextMaterial1, inputTextMaterial2, inputTextWPS, inputTextWeldType, inputTextStatus, inputTextInspectionCategory, inputTextInspectionCategoryType, inputTextInspectionPercent, dictionariesData, setOptionsMaterial1, setOptionsMaterial2, setOptionsWPS, setOptionsWeldType, setOptionsStatus, setOptionsInspectionCategory, setOptionsInspectionCategoryType, setOptionsInspectionPercent]);

  useEffect(() => {
    if (weldersData?.people?.list) {
      const welderOptions = weldersData.people.list.map(welder => ({
        id: welder.id,
        label: welder.name
      }));
      setOptionsWelders(welderOptions);
    }
  }, [weldersData]);

  const status_default_color = '#D5D5D5'

  const statuses_colors = { 'new': status_default_color, 'in_progress': '#FFA500', 'ready': '#398E3C', 'faild': '#FC0101', 'ok': '#359843', 'inconsistent': '#532D8E' }

  const weld_typeSelected = useMemo(
    () => optionsWeldType?.find((weld_type) => weld_type.id === urlParams.weld_joint_type),
    [optionsWeldType, urlParams.weld_joint_type]
  )

  const material_1Selected = useMemo(
    () => optionsMaterial1?.find((material_1) => material_1.id === urlParams.material_1),
    [optionsMaterial1, urlParams.material_1]
  )

  const material_2Selected = useMemo(
    () => optionsMaterial2?.find((material_2) => material_2.id === urlParams.material_2),
    [optionsMaterial2, urlParams.material_2]
  )

  const wpsSelected = useMemo(
    () => optionsWPS?.find((wps) => wps.id === urlParams.wps),
    [optionsWPS, urlParams.wps]
  )

  const statusSelected = useMemo(
    () => optionsStatus?.find((status) => status.id === urlParams.status),
    [optionsStatus, urlParams.status]
  )

  const inspectionCategorySelected = useMemo(
    () => optionsInspectionCategory?.find((category) => category.id === urlParams.inspection_category),
    [optionsInspectionCategory, urlParams.inspection_category]
  )

  const transformStatuses = (statuses) => {
    let statuses_hash = {}
    statuses.forEach((status) => {
      statuses_hash[status.id] = {
        label: status.label,
        color: statuses_colors[status.id] || status_default_color,
      }
    })
    return statuses_hash
  }

  const statuses = useMemo(
    () => transformStatuses(optionsStatus),
    [optionsStatus]
  );

  const getWeldType = (type_of_welds, joint_types) => {
    let weld_types = []
    type_of_welds.forEach((type_of_weld) => {
      if (type_of_weld.name === "BW" || type_of_weld.name === "T-joint") {
        weld_types = [...weld_types, { id: `${type_of_weld.id}`, label: type_of_weld.name }]
        joint_types.forEach((joint_type) => {
          weld_types = [...weld_types, { id: `${type_of_weld.id}-${joint_type.id}`, label: `${type_of_weld.name}-${joint_type.name}` }]
        })
      } else {
        weld_types = [...weld_types, { id: `${type_of_weld.id}`, label: type_of_weld.name }]
      }
    })
    return weld_types
  }

  const handleFilterChange = (key, value) => {
    // Convert inspection_percent to integer if it's not empty
    if (key === "inspection_percent" && value !== "") {
      value = parseInt(value, 10);
    }
    // Handle 'no' field by splitting on comma and trimming
    if (key === "no" && value !== "") {
      value = value.split(',').map(val => val.trim());
    }
    setTempFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  const handlePageChange = (event, value) => {
    setSearchParams((prevFilters) => ({
      ...clearHash(urlParams),
      page: value,
    }));
    setUrlParams((prevFilters) => ({
      ...prevFilters,
      page: value,
    }));
  };

  const handlePageSizeChange = (event) => {
    const newSize = event.target.value;
    setPageSize(newSize);
    setSearchParams((prevFilters) => ({
      ...clearHash(urlParams),
      size: newSize,
      page: 1
    }));
    setUrlParams((prevFilters) => ({
      ...prevFilters,
      size: newSize,
      page: 1
    }));
  };

  const handleApplyFilters = () => {
    // Process filters before setting search params
    const processedFilters = Object.entries(tempFilters)
      .filter(([_, value]) => value !== null && value !== '')
      .reduce((acc, [key, value]) => {
        // Convert inspection_percent to integer for the URL
        if (key === 'inspection_percent' && value !== '') {
          acc[key] = parseInt(value, 10);
        } else {
          acc[key] = value;
        }
        return acc;
      }, {});

    setSearchParams(processedFilters);
    setUrlParams(processedFilters);

    // Ensure we're using the processed filters for the API call
    refetch({
      page: processedFilters.page || urlParams.page,
      size: processedFilters.size || urlParams.size,
      elementId: elementId,
      projectId: projectId,
      filters: clearHash(removeFromHash(processedFilters, 'page', 'size')),
    });
  };

  const resetFilters = async () => {
    setSearchParams({});
    window.location.reload();
  };

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAll(checked);
    if (checked) {
      setSelectedWelds(welds.map(weld => weld.id));
    } else {
      setSelectedWelds([]);
    }
  };

  const handleSelectWeld = (weldId) => {
    setSelectedWelds(prev => {
      const newSelected = prev.includes(weldId)
        ? prev.filter(id => id !== weldId)
        : [...prev, weldId];
      setSelectAll(newSelected.length === welds.length);
      return newSelected;
    });
  };

  const handleBulkWelding = () => {
    const weldIds = selectedWelds.join(',');
    const currentUrl = btoa(window.location.href);
    window.location.href = `/welding/${projectId}/${elementId}/${weldIds}?backUrl=${currentUrl}`;
  };

  const handleBulkInspection = () => {
    const weldIds = selectedWelds.join(',');
    const currentUrl = btoa(window.location.href);
    window.location.href = `/inspection/${projectId}/${elementId}/${weldIds}?backUrl=${currentUrl}`;
  };

  if (loading && !applyFilters)
    return (
      <Box sx={{ width: "100%" }}>
        <LinearProgress />
      </Box>
    );
  if (error) return <Alert severity='error'>{error.message}</Alert>;

  const welds = data?.welds?.list || [];
  const metadata = data?.welds?.metadata || [];

  const Item = styled(Paper)(({ theme, statusColor }) => ({
    backgroundColor: statusColor,
    textAlign: "center",
    padding: theme.spacing(1),
  }));

  const statusItem = (weld) => {
    return (
      <Item
        variant='contained'
        sx={{
          backgroundColor: statuses[weld.status]['color'],
          fontSize: "12px",
        }}
      >
        {statuses[weld.status]['label']}
      </Item>
    );
  };

  const handleOnClick = (weld_id) => {
    const currentUrl = btoa(window.location.href);
    window.location.href = `/welding/${projectId}/${elementId}/${weld_id}?backUrl=${currentUrl}`;
  };

  const handleOnClickInspection = (weld_id) => {
    const currentUrl = btoa(window.location.href);
    window.location.href = `/inspection/${projectId}/${elementId}/${weld_id}?backUrl=${currentUrl}`;
  };

  const actionButton = (weld) => {
    if (!permissions || !permissions.wl_welds) return null;
    
    return (permissions?.wl_welds?.welding_logs?.create || permissions?.wl_welds?.grinding_logs?.create || permissions?.wl_welds?.inspection_logs?.create) ? (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {["ready", "in_progress", "failed"].includes(weld.status) && (permissions?.wl_welds?.welding_logs?.create || permissions?.wl_welds?.grinding_logs?.create) && weld.welding_progress < 100 && (<Button
          endIcon={<KeyboardDoubleArrowRightIcon />}
          onClick={() => {
            handleOnClick(weld.id);
          }}
          variant='outlined'
          size='small'
          sx={{ fontSize: '10px', lineHeight: 1.2 }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span>Welding</span>
            <span>Grinding</span>
          </Box>
        </Button>)}

        {["ready", "in_progress"].includes(weld.status) && permissions?.wl_welds?.inspection_logs?.create && (<Button
          endIcon={<KeyboardDoubleArrowRightIcon />}
          onClick={() => {
            handleOnClickInspection(weld.id);
          }}
          variant='outlined'
          size='small'
          sx={{ color: "green", borderColor: "green" }}
        >
          Inspection
        </Button>)}
      </Box>
    ) : null;
  };

  return (
    <Container sx={{ paddingTop: 4 }}>
      <form onSubmit={(e) => {
        e.preventDefault();
        handleApplyFilters();
      }} style={{ padding: '1px', fontSize: '12px' }}>
        <TableContainer component={Paper} sx={{ maxHeight: 1000 }}>
          <Table>
            <TableHead
              sx={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                mt: 4,
                zIndex: 2,
              }}
            >
              <TableRow>
                <TableCell>
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    indeterminate={selectedWelds.length > 0 && selectedWelds.length < welds.length}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    label='No'
                    defaultValue={urlParams.no}
                    variant='outlined'
                    size='small'
                    fullWidth
                    onChange={(e) => handleFilterChange("no", e.target.value)}
                    type="string"
                    sx={{
                      minWidth: "40px",
                      width: "70px",
                      fontSize: '12px',
                      '& .MuiInputBase-input': { fontSize: '12px' },
                      '& .MuiInputLabel-root': { fontSize: '12px' },
                      // Remove arrows in Chrome, Safari, Edge, Opera
                      '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 0
                      },
                      // Remove arrows in Firefox
                      '& input[type=number]': {
                        '-moz-appearance': 'textfield'
                      }
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    value={weld_typeSelected ? weld_typeSelected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("weld_joint_type", value?.id || "")
                    }
                    options={optionsWeldType}
                    filterOptions={(optionsWeldType) => optionsWeldType}
                    onInputChange={(event, newValue) => {
                      setInputTextWeldType(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='W type'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 100, fontSize: '12px', p: 0 }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                </TableCell >
                <TableCell >
                  <TextField
                    type="number"
                    label='Length'
                    defaultValue={urlParams.length}
                    variant='outlined'
                    size='small'
                    fullWidth
                    onChange={(e) => handleFilterChange("length", e.target.value)}
                    sx={{
                      minWidth: "50px",
                      width: "80px",
                      fontSize: '12px',
                      '& .MuiInputBase-input': { fontSize: '12px' },
                      '& .MuiInputLabel-root': { fontSize: '12px' },
                      // Remove arrows in Chrome, Safari, Edge, Opera
                      '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                        '-webkit-appearance': 'none',
                        margin: 0
                      },
                      // Remove arrows in Firefox
                      '& input[type=number]': {
                        '-moz-appearance': 'textfield'
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "100px", padding: "1px" }}>
                  <Autocomplete
                    value={material_1Selected ? material_1Selected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("material_1", value?.id || "")
                    }
                    options={optionsMaterial1}
                    filterOptions={(optionsMaterial1) => optionsMaterial1}
                    onInputChange={(event, newValue) => {
                      setInputTextMaterial1(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Mat 1'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 100, fontSize: '12px', p: 0, mb: '9px' }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                  <Autocomplete
                    value={material_2Selected ? material_2Selected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("material_2", value?.id || "")
                    }
                    options={optionsMaterial2}
                    filterOptions={(optionsMaterial2) => optionsMaterial2}
                    onInputChange={(event, newValue) => {
                      setInputTextMaterial2(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Mat 2'
                        variant='outlined'
                        size='small'
                        value="{urlParams.material_2}"
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 100, fontSize: '12px', p: 0 }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "100px", padding: "1px" }}>
                  <Autocomplete
                    value={wpsSelected ? wpsSelected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("wps", value?.id || "")
                    }
                    options={optionsWPS}
                    filterOptions={(optionsWPS) => optionsWPS}
                    onInputChange={(event, newValue) => {
                      setInputTextWPS(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='WPS'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 100, fontSize: '12px', p: 0 }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          },
                          width: '200px !important',
                          minWidth: '200px !important'
                        }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "120px", padding: "1px" }}>
                  <Autocomplete
                    value={welderSelected ? welderSelected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("last_welding_welder_id", value?.id || "")
                    }
                    options={optionsWelders}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Welder'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 120, fontSize: '12px', p: 0, mb: '9px' }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                  <TextField
                    type="date"
                    label='Date'
                    defaultValue={urlParams.last_welding_date}
                    variant='outlined'
                    size='small'
                    fullWidth
                    onChange={(e) => handleFilterChange("last_welding_date", e.target.value)}
                    sx={{
                      width: 120,
                      fontSize: '12px',
                      '& .MuiInputBase-input': { fontSize: '12px' },
                      '& .MuiInputLabel-root': { fontSize: '12px' }
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                </TableCell>
                {/* <TableCell sx={{ width: "120px", padding: "1px" }}>
                  <Autocomplete
                    value={inspectionCategorySelected ? inspectionCategorySelected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("inspection_category", value?.id || "")
                    }
                    options={optionsInspectionCategory || []}
                    onInputChange={(event, newValue) => {
                      setInputTextInspectionCategory(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Insp Cat'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 120, fontSize: '12px', p: 0 }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                </TableCell> */}
                <TableCell sx={{ width: "120px", padding: "10px" }}>
                  <Autocomplete
                    value={inspectionCategoryTypeSelected ? inspectionCategoryTypeSelected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("empty_inspection_category_type", value?.id || "")
                    }
                    options={optionsInspectionCategoryType}
                    filterOptions={(optionsInspectionCategoryType) => optionsInspectionCategoryType}
                    onInputChange={(event, newValue) => {
                      setInputTextInspectionCategoryType(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Requere inspection'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 120, fontSize: '12px', p: 0, mb: '9px' }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                  <Autocomplete
                    value={inspectionPercentSelected ? inspectionPercentSelected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("inspection_percent", value?.id || "")
                    }
                    options={optionsInspectionPercent}
                    filterOptions={(optionsInspectionPercent) => optionsInspectionPercent}
                    onInputChange={(event, newValue) => {
                      setInputTextInspectionPercent(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Insp %'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 120, fontSize: '12px', p: 0 }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "120px", padding: "1px" }}>
                  <Autocomplete
                    value={statusSelected ? statusSelected["label"] : ""}
                    onChange={(event, value) =>
                      handleFilterChange("status", value?.id || "")
                    }
                    options={optionsStatus}
                    filterOptions={(optionsStatus) => optionsStatus}
                    onInputChange={(event, newValue) => {
                      setInputTextStatus(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Status'
                        variant='outlined'
                        size='small'
                        fullWidth
                        sx={{ '& .MuiInputBase-input': { fontSize: '12px' }, '& .MuiInputLabel-root': { fontSize: '12px' } }}
                      />
                    )}
                    sx={{ width: 120, fontSize: '12px', p: 0 }}
                    componentsProps={{
                      popper: {
                        sx: {
                          '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                          }
                        }
                      }
                    }}
                  />
                </TableCell>

                <TableCell sx={{ padding: "1px", textAlign: "center" }}>
                  <Button
                    type="submit"
                    size='small'
                    sx={{ marginRight: "8px", fontSize: '12px', padding: '8px 16px', minWidth: '50px' }}
                    variant='contained'
                    color='primary'
                  >
                    <SearchIcon sx={{ fontSize: '16px' }} />
                  </Button>
                  <Button
                    type="button"
                    size='small'
                    sx={{
                      backgroundColor: "#F70000",
                      fontSize: '12px',
                      padding: '8px 16px',
                      minWidth: '50px'
                    }}
                    variant='contained'
                    onClick={resetFilters}
                  >
                    <ClearIcon sx={{ fontSize: '16px' }} />
                  </Button>
                </TableCell>
              </TableRow >
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell>
                  {selectedWelds.length > 0 && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      {(permissions?.wl_welds?.welding_logs?.create || permissions?.wl_welds?.grinding_logs?.create) && (<Button
                        variant='contained'
                        onClick={handleBulkWelding}
                        size='small'
                        sx={{ minWidth: '80px', fontSize: '10px', lineHeight: 1.2 }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <span>Welding</span>
                          <span>Grinding</span>
                        </Box>
                      </Button>)}
                      {permissions?.wl_welds?.inspection_logs?.create && (<Button
                        variant='contained'
                        onClick={handleBulkInspection}
                        size='small'
                        sx={{ backgroundColor: 'green', minWidth: '80px' }}
                      >
                        Inspection
                      </Button>)}
                    </Box>
                  )}
                </TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>No</TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Weld Type</TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Length</TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Materials</TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>WPS</TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Welder</TableCell>
                {/* <TableCell>Inspection Category</TableCell> */}
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Inspection Category Type</TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Status</TableCell>
                <TableCell sx={{ fontSize: '12px', fontWeight: 'bold' }}>Action</TableCell>
              </TableRow>
            </TableHead >
            <TableBody>
              {welds.map((weld) => (
                <TableRow key={weld.id}>
                  <TableCell sx={{ fontSize: '12px' }}>
                    <Checkbox
                      checked={selectedWelds.includes(weld.id)}
                      onChange={() => handleSelectWeld(weld.id)}
                    />
                  </TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>{weld.no}</TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>
                    {Array.isArray(weld.weld_joint_type) && weld.weld_joint_type.length > 0 ?
                      weld.weld_joint_type.map((wjt, index) => {
                        if (wjt.weld_type?.name && wjt.joint_type?.name) {
                          return `${wjt.weld_type.name}-${wjt.joint_type.name}`;
                        } else if (wjt.weld_type?.name) {
                          return `${wjt.weld_type.name}`;
                        }
                        return null;
                      }).filter(Boolean).join(', ') : "-"
                    }
                  </TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>{weld.length}</TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>{weld.material_1?.designation_name || "-"}<br />{weld.material_2?.designation_name || "-"}</TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>
                    {Array.isArray(weld.wps) && weld.wps.length > 0 ?
                      weld.wps.map((wpsItem, index) => (
                        <div key={wpsItem.id}>
                          {wpsItem.no}
                        </div>
                      )) : "-"
                    }
                  </TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>
                    {weld.welder?.person ? (
                      <div>
                        <div>{weld.welder.person.last_name} {weld.welder.person.uuid}</div>
                        <div>{weld.welder.date}</div>
                      </div>
                    ) : "-"}
                  </TableCell>
                  {/* <TableCell>{weld.inspection_category?.name || "-"}</TableCell> */}
                  <TableCell sx={{ fontSize: '12px' }}>
                    {weld.inspection_category?.inspections?.length > 0 ? (
                      <div style={{ whiteSpace: 'pre-line' }}>
                        {[...weld.inspection_category.inspections]
                          .sort((a, b) => Number(a.type_id) - Number(b.type_id))
                          .map(insp => {
                            const typeName = dictionariesData?.inspection_category_types?.find(t => t.id === insp.type_id)?.name || `Type ${insp.type_id}`;
                            const parsedInspections = weld.inspections ?
                              (typeof weld.inspections === 'string' ? JSON.parse(weld.inspections) : weld.inspections) : {};
                            const inspectionData = parsedInspections[String(insp.type_id)];
                            const color = inspectionData ?
                              (inspectionData.skipped ? 'orange' : (inspectionData.positive ? 'green' : 'red')) : 'black';
                            const fontWeight = inspectionData ? 'bold' : 'normal';
                            const displayText = inspectionData ?
                              `${typeName} - ${inspectionData.date}` :
                              `${typeName} - ${insp.range || '100'}%`;
                            return (
                              <div key={insp.type_id} style={{ color, fontWeight }}>
                                {displayText}
                              </div>
                            );
                          })}
                      </div>
                    ) : "-"}
                  </TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>{statusItem(weld)}</TableCell>
                  <TableCell sx={{ fontSize: '12px' }}>{actionButton(weld)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table >
        </TableContainer >
      </form>
      <Stack spacing={2}>
        {metadata.total_pages > 0 && (
          <Box sx={{ position: "relative", display: "flex", justifyContent: "center", alignItems: "center", padding: "12px" }}>
            <Pagination
              onChange={handlePageChange}
              page={urlParams.page}
              count={metadata.total_pages}
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                />
              )}
            />
            <Box sx={{ position: "absolute", right: 0, display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2">Page size:</Typography>
              <Select
                value={pageSize}
                onChange={handlePageSizeChange}
                size="small"
                sx={{ minWidth: 80 }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={250}>250</MenuItem>
                <MenuItem value={500}>500</MenuItem>
              </Select>
            </Box>
          </Box>
        )}
        {parseInt(metadata.total_pages) === 0 && (
          <Box>
            <Typography
              variant="h5"
              sx={{
                textAlign: "center",
                padding: "12px",
                background: "#D5D5D5",
                color: "#ffffff",
                fontWeight: "bold",
              }}
            >
              No results found
            </Typography>
          </Box>
        )}
      </Stack>
    </Container >
  );
}
